import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { produce } from 'immer'

import { GetFacebookFeedResponse } from '@3m5/sm_publish-frontend-api/models'

import { ApiError } from '../../store/networkContentRoot.reducer'

import {
  getFacebookFeedForPage,
} from './facebook.actions'

export interface FacebookState {
  fetching: boolean
  facebookFeeds?: GetFacebookFeedResponse
  error: ApiError
}

const INITIAL_STATE: FacebookState = {
  fetching: false,
  error: {},
}

export const facebookReducer = reducerWithInitialState(INITIAL_STATE)
  /**
   * getFacebookFeedForPage
   */
  .case(getFacebookFeedForPage.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.loadFacebookFeedForPage
    })
  })

  .case(getFacebookFeedForPage.done, (state, { result }) => {
    return produce(state, draft => {
      draft.facebookFeeds = result
      draft.fetching = false
    })
  })

  .case(getFacebookFeedForPage.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.loadFacebookFeedForPage = (error as Response)
    })
  })
